module.exports = __webpack_public_path__ + "d85931bf.svg";